import { actionTypes } from "../actions/companies";

const variable = (state = null, action) => {
  switch (action.type) {
    case actionTypes.FETCH_COMPANY:
      return action.payload;
    default:
      return state;
  }
};

export default variable;